import { useState } from "react";

const GaugeChart = ({
    segments = [],
    total = 0,
    centerValue,
    centerLabel,
    height = 240,
}) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const cx = 100;
    const cy = 100;
    const r = 88;
    const ir = 62;

    const point = (angle, radius) => {
        const rad = (angle * Math.PI) / 180;
        return {
            x: cx + radius * Math.cos(rad),
            y: cy - radius * Math.sin(rad),
        };
    };

    let cumulative = 0;
    const arcs = segments.map((seg) => {
        const frac = total > 0 ? seg.value / total : 0;
        const start = 180 - cumulative * 180;
        cumulative += frac;
        const end = 180 - cumulative * 180;

        const outerStart = point(start, r);
        const outerEnd = point(end, r);
        const innerStart = point(start, ir);
        const innerEnd = point(end, ir);

        const path = [
            `M ${innerStart.x} ${innerStart.y}`,
            `L ${outerStart.x} ${outerStart.y}`,
            `A ${r} ${r} 0 0 1 ${outerEnd.x} ${outerEnd.y}`,
            `L ${innerEnd.x} ${innerEnd.y}`,
            `A ${ir} ${ir} 0 0 0 ${innerStart.x} ${innerStart.y}`,
            "Z",
        ].join(" ");

        return { path, color: seg.color, name: seg.name, value: seg.value };
    });

    const hovered =
        hoveredIndex !== null ? arcs[hoveredIndex] : null;

    return (
        <div
            style={{
                width: "100%",
                height,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                position: "relative",
            }}
        >
            <div style={{ position: "relative", width: "100%", flex: 1 }}>
                {hovered && (
                    <div
                        style={{
                            position: "absolute",
                            top: "8px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            backgroundColor: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            padding: "6px 12px",
                            fontSize: "14px",
                            color: "#333",
                            zIndex: 10,
                            pointerEvents: "none",
                            whiteSpace: "nowrap",
                        }}
                    >
                        <span style={{ fontWeight: 600 }}>
                            {hovered.name}:
                        </span>{" "}
                        {hovered.value}
                    </div>
                )}
                <svg
                    viewBox="0 0 200 112"
                    width="100%"
                    height="100%"
                    style={{ display: "block" }}
                >
                    {arcs.map((arc, index) => (
                        <path
                            key={index}
                            d={arc.path}
                            fill={arc.color}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                            style={{ cursor: "pointer", transition: "opacity 0.2s" }}
                            opacity={
                                hoveredIndex !== null &&
                                hoveredIndex !== index
                                    ? 0.6
                                    : 1
                            }
                        />
                    ))}
                </svg>
                {centerValue !== undefined && (
                    <div
                        style={{
                            position: "absolute",
                            left: "50%",
                            top: "78%",
                            transform: "translate(-50%, -50%)",
                            textAlign: "center",
                            pointerEvents: "none",
                        }}
                    >
                        <div
                            style={{
                                fontSize: "22px",
                                fontWeight: 700,
                                color: "#0b6775",
                                lineHeight: 1.1,
                            }}
                        >
                            {centerValue}
                        </div>
                        {centerLabel && (
                            <div
                                style={{
                                    fontSize: "12px",
                                    color: "#666",
                                    marginTop: "2px",
                                }}
                            >
                                {centerLabel}
                            </div>
                        )}
                    </div>
                )}
            </div>

            <div
                style={{
                    display: "flex",
                    gap: "16px",
                    justifyContent: "center",
                    marginTop: "8px",
                }}
            >
                {arcs.map((arc, index) => (
                    <div
                        key={index}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            fontSize: "13px",
                            color: "#666",
                        }}
                    >
                        <span
                            style={{
                                width: "12px",
                                height: "12px",
                                borderRadius: "50%",
                                background: arc.color,
                                flexShrink: 0,
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            }}
                        ></span>
                        <span>
                            {arc.name}{" "}
                            <strong style={{ color: "#333" }}>
                                {arc.value}
                            </strong>
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GaugeChart;
